import { Radio, RadioGroup } from '../../components/Radio';
import type { SignupSport } from '../../types/signup';
import { sportLabel } from './signupFormat';

/**
 * One radio per sport the school offers.
 *
 * Every sport is offered: the anonymous lookup does not say which programs exist (that would
 * disclose the customer list), so a taken one is refused by the create step, after the address is
 * verified.
 */
export const SignupSportChoice = ({
  sports,
  value,
  onChange,
  onBlur,
  error,
  disabled,
}: {
  sports: SignupSport[];
  value: SignupSport | undefined;
  onChange: (sport: SignupSport) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
}) => (
  <div className="signup-sports">
    <RadioGroup label="Sport" testId="signup-sports">
      {sports.map((sport) => (
        <Radio
          key={sport}
          name="sport"
          value={sport}
          label={sportLabel(sport)}
          checked={value === sport}
          onChange={() => onChange(sport)}
          onBlur={onBlur}
          disabled={disabled}
          aria-invalid={error ? true : undefined}
          data-testid={`signup-sport-${sport}`}
        />
      ))}
    </RadioGroup>
    {error && (
      <p className="signup-field-error" role="alert">
        {error}
      </p>
    )}
  </div>
);
